import Vue from "vue";

const VUE_APP_SIGFERIAS_SERVICES = process.env.VUE_APP_SIGFERIAS_SERVICES;

export const BaseService = {
  async fetchResponseFromAPIGet(endpoint) {
    const response = {
      content: [],
      error: "",
    };
    try {
      const data = await fetch(`${VUE_APP_SIGFERIAS_SERVICES}/${endpoint}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Vue.prototype.$keycloak.token,
        },
      });

      response.content = await data.json();
    } catch (e) {
      response.error = await e;
    }
    return response;
  },

  async fetchResponseFromAPIPost(endpoint, postData) {
    const data = {
      message: "",
      error: false,
    };

    let headers = {
      Accept: "application/json",
      Authorization: "Bearer " + Vue.prototype.$keycloak.token,
    };

    if (!(postData instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    try {
      let response;
      await fetch(`${VUE_APP_SIGFERIAS_SERVICES}/${endpoint}`, {
        method: "POST",
        headers,
        body: postData,
      }).then((result) => {
        response = result;
        if (!response.ok) {
          throw response.json();
        }

        data.message = response.json();
      });
    } catch (e) {
      data.error = true;
      data.message = await e;
    }
    return data;
  },

  async fetchResponseFromAPIPut(endpoint, postData) {
    const data = {
      message: "",
      error: false,
    };
    let headers = {
      Accept: "application/json",
      Authorization: "Bearer " + Vue.prototype.$keycloak.token,
    };

    if (!(postData instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    try {
      let response;
      await fetch(`${VUE_APP_SIGFERIAS_SERVICES}/${endpoint}`, {
        method: "PUT",
        headers,
        body: postData,
      }).then((result) => {
        response = result;
        if (!response.ok) {
          throw response.json();
        }

        data.message = response.json();
      });
    } catch (e) {
      data.error = true;
      data.message = await e;
    }

    return data;
  },

  async fetchResponseFromAPIDelete(endpoint) {
    const data = {
      message: "",
      error: false,
    };

    try {
      let response;
      await fetch(`${VUE_APP_SIGFERIAS_SERVICES}/${endpoint}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Vue.prototype.$keycloak.token,
        },
      }).then((result) => {
        response = result;
        if (!response.ok) {
          throw response.json();
        }

        data.message = response.json();
      });
    } catch (e) {
      data.error = true;
      data.message = await e;
    }

    return data;
  },

  async downloadItemPost(endpoint, postData) {
    const data = {
      message: "",
      error: false,
      file: null,
    };

    let headers = {
      Accept: "application/json",
      Authorization: "Bearer " + Vue.prototype.$keycloak.token,
    };

    if (!(postData instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    try {
      await fetch(`${VUE_APP_SIGFERIAS_SERVICES}/${endpoint}`, {
        method: "POST",
        headers,
        body: postData,
      }) 
      .then(res => {
        if(!res.ok){
          throw res.json();

        }
        return res.blob();
      }) 
      .then( blob => {
        var file = window.URL.createObjectURL(blob);
        window.location.assign(file);

      });
    } catch (e) {
      data.error = true;
      data.message = await e;
    }
    return data;
  },

};